/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// import { pxToEm, replacePXinStringWithEM } from '@insticator/insticator-ui'; // iui-utils
import { buttonStyles, textStyles } from "utils/themeV2";



/* ++++++++++ --------------- EXPORT : AUTH COMPLETE SIGNUP --------------- ++++++++++ */
export default theme => ({
	completesignup: {
		'& .icon':{
			cursor: 'pointer',
			zIndex: 5
		},
		...textStyles,
		...buttonStyles
	}
});
